import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";
import ContactForm from "../../../components/ContactForm/ContactForm";
import "./Contact.css";

// Update these with your real details
const CONTACT_EMAIL = "hello@eliteproperties.com";
const CONTACT_PHONE = "+91 98765 43210";

export default function Contact() {
  return (
    <div className="contact-page">
      <Navbar />

      <section className="contact-section">
        <div className="contact-container">
          {/* Left – Info */}
          <div className="contact-info">
            <div className="contact-eyebrow">Contact</div>
            <h1 className="contact-title">
              Let's talk about your next move.
            </h1>
            <p className="contact-copy">
              Tell us what you're looking for. A senior advisor will reach out
              within one working day.
            </p>

            <ul className="contact-details">
              <li>
                <Mail className="contact-icon" />
                <span>{CONTACT_EMAIL}</span>
              </li>
              <li>
                <Phone className="contact-icon" />
                <span>{CONTACT_PHONE}</span>
              </li>
              <li>
                <MapPin className="contact-icon" />
                <span>Mumbai · Delhi · Bangalore</span>
              </li>
            </ul>
          </div>

          {/* Right – Form */}
          <div className="contact-form-card">
            <ContactForm />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}